// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"856":"8777cbf4","935":"954b40f1"}[chunkId] + ".js";
};